import React, { useState, useEffect } from 'react';

import { Layout, Avatar, Menu, Card, Dropdown, Row, Col, Typography, Popover, Spin, Result, Tooltip, Button } from 'antd';
import {
	UserOutlined,
	LogoutOutlined,
	AppstoreOutlined,
	PieChartOutlined,
	DesktopOutlined,
	ContainerOutlined,
	MailOutlined,
} from '@ant-design/icons';


import './index.css';

import { errorCatch, GET, IfElse, LanguageContext, POST, QueryDetail, READWITH, TranslateContext, UserConfigContext, UserContext, ycStorage } from 'fennec-ui';
import useStyles from '../../../common/Styles';

import { useNavigate, useParams } from 'react-router-dom';
import { useAuth } from 'fennec-ui';
import dayjs from 'dayjs'
import 'dayjs/locale/ru'
import { Action } from 'fennec-ui'

import PaymentForm from '../../forms/PaymentForm'
import PaymentPreview from '../../forms/PaymentPreview'
import { useDispatch, useSelector } from 'react-redux';
import REDUX_AkkauntiPolzovatelei from '../../../objects/AkkauntiPolzovatelei/reducer';
import greenClock from '../../../green-clock.svg';
import SiteAccessDeny from '../SiteAccessDeny';
import { MetaContext } from 'fennec-ui';
import Icofont from 'react-icofont';
import REDUX_UserConfig from '../../../objects/UserConfig/reducer'
import REDUX_Translate from '../../../objects/Translate/reducer';
import { MaxIcon, translate, ycBucket } from '../../../common/Tool';
import YImage from '../../../common/YImage';

import FedHeader from '../FedHeader'
import FedSubheader from '../FedSubheader'
import { LangSwitchContext, useIsDesktopOrLaptopContext, useIsMobileContext, useLayoutWidthContext } from '../../../common/Context';
import LangSwitch from '../../components/LangSwitch';

var utc = require('dayjs/plugin/utc')
var timezone = require('dayjs/plugin/timezone') // dependent on utc plugin
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.locale('ru');

var _ = require('lodash');
const { SubMenu } = Menu;

const { Header, Content, Footer, Sider } = Layout;


const SingleEvent = (props) => {
	const classes = useStyles();
	const { auth, event, size } = props;

	const playbillSize = "78px";

	const sameDay = (start, end) => {
		var mstart = dayjs(start);
		var mend = dayjs(end);
		var year1 = mstart.year(), month1 = mstart.month(), day1 = mstart.date();
		var day1n = mstart.add(24, 'hour')
		var year2 = mend.year(), month2 = mend.month(), day2 = mend.date();
		var hour2 = mend.hour();
		if (year1 == year2 && month1 == month2 && ((day2 == day1) || (day2 == day1n && hour2 < 8))) {
			return true
		}
		return false
	};
	const kategorii = (data) => {
		let result = [];
		let mResult = new Map();
		if (data) {
			for (let idx = 0; idx < data.length; idx++) {
				const item = data[idx];
				let kat = mResult.get(item.tantsevalnayaDistsiplinaID);
				if (!kat) {
					kat = {
						tantsevalnayaDistsiplina: item.tantsevalnayaDistsiplina,
						kategoriiUchastnikov: [],
						mKategoriiUchastnikov: new Map(),
					}
					mResult.set(item.tantsevalnayaDistsiplinaID, kat);
					result.push(kat);
				}
				let ok = kat.mKategoriiUchastnikov.get(item.kategoriyaUchastnikovID);
				if (!ok) {
					kat.mKategoriiUchastnikov.set(item.kategoriyaUchastnikovID, data[idx].kategoriyaUchastnikov)
					kat.kategoriiUchastnikov.push(data[idx].kategoriyaUchastnikov);
				}
			}
		}

		for (let idx = 0; idx < result.length; idx++) {
			result[idx].kategoriiUchastnikov.sort((a, b) => a.ID - b.ID);
		}

		result.sort((a, b) => a.tantsevalnayaDistsiplina.ID - b.tantsevalnayaDistsiplina.ID);

		return result
	}
	const kategoriiView = (e) => {
		const list = kategorii(e.kategoriiUchastnikovNaMeropriyatiyakhMeropriyatie);
		if (list.length <= 0) return <></>;
		return (
			<div key="q4" style={{ textOverflow: "initial", whiteSpace: "normal", marginTop: "0px" }}>
				<div className={classes.fieldName}>Категории:</div>
				<ul style={{ listStyle: "none", paddingInlineStart: "2px", fontSize: "13px" }}>
					{list.map((kat, i) => {
						return <li key={i}>
							{kat.tantsevalnayaDistsiplina.nazvanie + " "}
							({
								kat.kategoriiUchastnikov.map((itemD, idx) => {
									if (idx + 1 < kat.kategoriiUchastnikov.length) {
										return <span key={idx}>{itemD.nazvanie.toLowerCase() + ", "}</span>
									} else {
										return <span key={idx}>{itemD.nazvanie.toLowerCase()}</span>
									}
								})
							})
						</li>
					})}
				</ul>
			</div>
		);
	};
	if (!event) return <></>;
	const appendToArray = (target, source) => {
		if (!target) return source;
		return (!source) ? target : [...target, ...source];
	}
	return (
		<div className="event-block" style={{ display: "flex", justifyContent: "space-between" }}>
			<div style={{ maxWidth: "78px" }}>
				{(size !== "small") && <div style={{ width: playbillSize, height: playbillSize, overflow: "hidden" }}>
					<YImage item={event} width={78} hidePreview={true} />
					{/* <YImage image={e.afisha} minimage={e.afishaMin} width={imgSize} /> */}
				</div>}
				<div style={(size !== "small") ? { marginTop: "7px" } : {}}>
					<div style={{
						backgroundColor: "#eaeaea",
						fontSize: "16px",
						fontWeight: "400",
						color: "black",
						borderRadius: "6px",
						textAlign: "center",
						padding: "0 7px",
						textAlign: "center",
					}}>
						<div style={{
							borderRadius: "5px",
							backgroundColor: "#f6214b",
							fontSize: "12px",
							fontWeight: "600",
							color: "white",
							margin: "0 -7px",
							boxShadow: "0px 6px 5px -5px rgb(34 60 80 / 60%",
							padding: "3px 7px"
						}}>
							{dayjs(event.nachaloSorevnovaniya).tz("Europe/Moscow").format('DD.MM.YYYY')}
							{/* {true === sameDay(event.nachaloSorevnovaniya, event.okonchanieSorevnovaniya) &&
								dayjs(event.nachaloSorevnovaniya).tz("Europe/Moscow").format('DD.MM.YYYY')
							}
							{true !== sameDay(event.nachaloSorevnovaniya, event.okonchanieSorevnovaniya) &&
								<>
									<div style={{ fontSize: "16px" }}>
										{dayjs(event.nachaloSorevnovaniya).tz("Europe/Moscow").format('DD')}
										-
										{dayjs(event.okonchanieSorevnovaniya).tz("Europe/Moscow").format('DD')}
									</div>
									<div style={{ fontSize: "14px" }}>
										{dayjs(event.nachaloSorevnovaniya).tz("Europe/Moscow").format('MMMM')} {dayjs(event.nachaloSorevnovaniya).tz("Europe/Moscow").format('YYYY')}
									</div>
								</>
							} */}
						</div>
						<div style={{
							fontSize: "10px",
							fontWeight: "400",
							padding: "0px"
						}}>
							{dayjs(event.nachaloSorevnovaniya).tz("Europe/Moscow").format('dddd')}
							{/* {true === sameDay(event.nachaloSorevnovaniya, event.okonchanieSorevnovaniya) && <>
								{dayjs(event.nachaloSorevnovaniya).tz("Europe/Moscow").format('dddd')}
							</>}
							{true !== sameDay(event.nachaloSorevnovaniya, event.okonchanieSorevnovaniya) && <>
								{dayjs(event.nachaloSorevnovaniya).tz("Europe/Moscow").format('dddd')}
								<span> - </span>
								{dayjs(event.okonchanieSorevnovaniya).tz("Europe/Moscow").format('dddd')}
							</>} */}
						</div>
					</div>
				</div>
			</div>
			<div style={{ flex: "auto", paddingLeft: "7px" }}>
				<div key="q1" style={{ textOverflow: "initial", whiteSpace: "normal", marginTop: "0px" }}>
					{/* <span className={classes.fieldName}>Название: </span> */}
					<span className={classes.fieldValue} style={{ fontWeight: "600", fontSize: (size !== "small") ? "14px" : "18px" }}>
						<a href={`/fed/event/${event.ID}`}>{event.nazvanieMeropriyatiya}</a>
					</span>
				</div>
				<div key="q2" style={{ textOverflow: "initial", whiteSpace: "normal", marginTop: "0px" }}>
					<span className={classes.fieldName}>Уровень: </span><span className={classes.fieldValue}>{event.urovenMeropriyatiya.opisanie}</span>
				</div>
				<div key="q3" style={{ textOverflow: "initial", whiteSpace: "normal", marginTop: "0px" }}>
					<span className={classes.fieldName}>Место проведения: </span>
					<span className={classes.fieldValue}>{event.mestoProvedeniya.name}</span>
				</div>
				{(size !== "small") && kategoriiView(event)}
			</div>
		</div>
	);
}

function Payment(props) {
	let navigate = useNavigate();
	let { id } = useParams();
	const auth = useAuth();
	const classes = useStyles();
	const dispatch = useDispatch();
	const userConfig = useSelector(REDUX_UserConfig.selector.object) || {};
	const translates = useSelector(REDUX_Translate.selector.object);
	const [language, setLanguage] = useState({ lang: (auth.getCookie("lang") || "ru") })
	const t = React.useMemo(() => _.bind(translate, {
		translate: translates,
		config: language
	}), [translates, language]);
	// const t = useTranslateContext();
	// console.log(t("да"));

	const setUserConfig = (name, value, onChange) => {
		POST(auth, "/api/setuserconfig", {
			key: name,
			value: value
		}, ({ data }) => {
			var arr = [data];
			var obj = Object.fromEntries(arr.map(i => {
				return [
					i.key,
					i.value
				]
			}));
			let i = { ...userConfig, ...obj };
			let o = REDUX_UserConfig.actions.setObject(i);
			dispatch(o);
			if (onChange) {
				onChange(i);
			}
		}, errorCatch);
	};

	const { history } = props;

	const maxbot = process.env.REACT_APP_MAXBOT

	//-------------------------------------------------------------
	const [layout, setLayout] = useState("web"); // app | web
	const [showContentMenu, setShowContentMenu] = useState(false);
	const [showRightSider, setShowRightSider] = useState(false);
	const [showLeftSider, setShowLeftSider] = useState(false);
	const [showHeader, setShowHeader] = useState(false);
	const [showSubheader, setShowSubheader] = useState(true);
	const [loading, setLoading] = useState(false);
	const [fullwidth, setFullwidth] = useState(false);
	//-------------------------------------------------------------

	const meta = useSelector(state => state.meta);

	const [collapsed, setCollapsed] = useState(true);
	const [user, setUser] = useState();
	const [event, setEvent] = useState(undefined);
	const siteAccess = useSelector(state => state.siteAccess.value);

	useEffect(() => {
		subscribe();
		return () => {
			unsubscribe();
		};
	}, []);
	const subscribe = () => {
		auth.fetch('/api/meta').then(res => {
			if (res && res.data && dispatch) {
				dispatch({ type: 'META', payload: res.data })
			}
		});
		auth.fetch('/api/iam').then(res => {
			if (res && res.data) {
				setUser(res.data);
			}
		});
		setLoading(true);
		GET(auth, "/api/meropriyatiya/list/com?detail=model&w-id=" + id,
			({ data }) => {
				if (data && data.length) {
					setEvent(data[0]);
				}
				setLoading(false);
			}, (err) => errorCatch(err, () => setLoading(false)));
		RefreshAkkaunti();
		auth.openSocket("/ws/service", "service", function (type, payload) {
			if (type === "reload") {
				window.location.href = window.location.href;
			}
			switch (type) {
				case "siteaccess":
					dispatch({ type: "SITE_ACCESS", payload: payload });
					break;
				case "NeedUpdateAkkauntPolzovatelya":
					RefreshAkkaunti();
					break;
				case "AkkauntiPolzovatelei":
					dispatch(REDUX_AkkauntiPolzovatelei.actions.updateArray([payload]));
					break;
				default:
					break;
			}
		});
	};

	const _RefreshAkkaunti = () => {
		READWITH(auth, "AkkauntiPolzovatelei", [
			QueryDetail("model")
		], ({ data }) => {
			if (data) {
				dispatch(REDUX_AkkauntiPolzovatelei.actions.updateArray(data));
			}
		}, errorCatch);
	};
	var RefreshAkkaunti = _.throttle(_RefreshAkkaunti, 3000, { 'trailing': false });

	const unsubscribe = () => {
		auth.closeSocket("service");
	};
	const logout = () => {
		auth.logout(() => {
			navigate('/app');
			// history.go(0);
		});
	}
	const logoutall = () => {
		auth.logoutall(() => {
			navigate('/app');
			// history.go(0);
		});
	}
	const [layoutWidth, setLayoutWidth] = useLayoutWidthContext();
	const isMobile = useIsMobileContext();
	const isDesktopOrLaptop = useIsDesktopOrLaptopContext();
	const style = () => {
		return {
			fullwidth: {
				layout: (fullwidth || !isDesktopOrLaptop) ? {} : { width: layoutWidth, margin: "0 auto" },
				header: (fullwidth || !isDesktopOrLaptop) ? {} : { width: layoutWidth, padding: "0", margin: "0 auto" },
			},
			content: {
				minHeight: 600,
				paddingTob: "0px",
				paddingRight: (!showRightSider) ? "0px" : "10px",
				paddingBottom: "0px",
				paddingLeft: (!showLeftSider) ? "0px" : "10px",
				// background: "white"
			}
		}
	};
	const changeFullwidth = () => {
		setFullwidth(!fullwidth ? true : false);
	};

	const actionFunc = React.useMemo(() => (values, unlock) => {
		setLoading(true);
		GET(auth, `/api/zakaz/payment/${id}?price=${(values.payment.byCard) ? values.payment.byCard : 0}`,
			(res) => {
				if (res.SuccessUrl) {
					navigate(res.SuccessUrl);
				} else if (res.PaymentUrl) {
					window.location.href = res.PaymentUrl;
				}
				unlock();
				setLoading(false);
			}, (err) => errorCatch(err, () => { setLoading(false); unlock(); }));
	}, []);
	const steps = React.useMemo(() => ([
		{
			key: "cart",
			name: "Шаг 1",
			event: event,
			action: (values, unlock, close) => {
				GET(auth, `/api/zakaz/opened/${event.ID}`, (res) => {
					close(res);
				}, (err) => errorCatch(err, unlock));
			},
			form: PaymentForm
		},
		{
			key: "payment",
			name: "Шаг 2",
			event: event,
			form: PaymentPreview,
		}
	]), [event]);
	return (
		<TranslateContext.Provider value={t}>
			<MetaContext.Provider value={meta}>
				<UserContext.Provider value={user}>
					<UserConfigContext.Provider value={[userConfig, setUserConfig]}>
						<LanguageContext.Provider value={[language, setLanguage]}>
							<LangSwitchContext.Provider value={<LangSwitch userConfig={userConfig} />}>
								{(!siteAccess || siteAccess == "allow") && <Layout>
									<FedHeader user={user} logout={logout} logoutall={logoutall} layout={layout} fullwidth={fullwidth} />
									{/* {showSubheader && <FedSubheader layout={layout} fullwidth={fullwidth} changeFullwidth={changeFullwidth} />} */}
									<Content style={{ padding: '6px' }}>
										<Layout style={style().fullwidth.layout}>
											{showLeftSider && <Sider theme="light"></Sider>}
											<Content style={{ ...style().content }}>
												<div style={{ display: "flex", justifyContent: "space-between" }}>
													{showContentMenu && <div style={{ backgroundColor: "white", marginRight: "5px" }}>
														{/* <Button type="text" onClick={() => setCollapsed(!collapsed)} style={{ marginBottom: 16 }}>
										{React.createElement(collapsed ? MenuUnfoldOutlined : MenuFoldOutlined)}
									</Button> */}
														<Menu
															defaultSelectedKeys={['1']}
															mode="inline"
															theme="light"
															inlineCollapsed={collapsed}
														>
															<Menu.Item key="1" icon={<PieChartOutlined />}>
																Option 1
															</Menu.Item>
															<Menu.Item key="2" icon={<DesktopOutlined />}>
																Option 2
															</Menu.Item>
															<Menu.Item key="3" icon={<ContainerOutlined />}>
																Option 3
															</Menu.Item>
															<SubMenu key="sub1" icon={<MailOutlined />} title="Navigation One">
																<Menu.Item key="5">Option 5</Menu.Item>
																<Menu.Item key="6">Option 6</Menu.Item>
																<Menu.Item key="7">Option 7</Menu.Item>
																<Menu.Item key="8">Option 8</Menu.Item>
															</SubMenu>
															<SubMenu key="sub2" icon={<AppstoreOutlined />} title="Navigation Two">
																<Menu.Item key="9">Option 9</Menu.Item>
																<Menu.Item key="10">Option 10</Menu.Item>
																<SubMenu key="sub3" title="Submenu">
																	<Menu.Item key="11">Option 11</Menu.Item>
																	<Menu.Item key="12">Option 12</Menu.Item>
																</SubMenu>
															</SubMenu>
														</Menu>
													</div>}
													<div style={{ flex: "auto" }}>
														{showHeader && <Row gutter={[5, 5]}>
															<Col span={24}>
																<Card size="small" bordered={false} className={classes.block}>Header</Card>
															</Col>
														</Row>}
														<div style={{ backgroundColor: "white", borderRadius: "4px" }}>
															<div style={{ padding: "10px" }}>
																<Spin spinning={!event?.ID || !user?.ID}>
																	{(event?.ID === 861 && user?.ID && !user.maxchatid) && <div>

																		<div>
																			<div style={{ fontSize: "20px", textAlign: "center", paddingBottom: "20px" }}>
																				<div style={{ fontWeight: "600" }}>
																					Для покупки подписки на Max-канал (видео Федерации) необходимо связать аккаунт в личном кабинете с аккаунтом в Max.
																				</div>
																				<div>
																					После связывания аккаунтов зайдите заново на страницу покупки подписки.
																				</div>

																			</div>
																			<div style={{ display: "flex", gap: "20px", justifyContent: "center", alignItems: "center" }}>
																				{(user) && <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
																					<div><img src='/resources/logo.png'></img></div>
																					<div>
																						<div>{user.lastname} {user.firstname}</div>
																						<div>{user.email}</div>
																					</div>
																				</div>}
																			</div>

																			<div style={{ display: "flex", justifyContent: "center", gap: "15px", paddingTop: "20px" }}>
																				<div style={{ paddingBottom: "20px", display: "flex", flexDirection: "column", gap: "10px" }}>
																					<div style={{ display: "flex", gap: "10px" }}>
																						<a target="_blank" href={(maxbot) ? 'https://max.ru/' + maxbot : "#"}>
																							<div className={`bg bg-grey light-10 pointer border-red`} style={{ padding: "5px 10px", display: "flex", gap: "10px", alignItems: "center", maxWidth: "300px" }}>
																								<div><MaxIcon width={22} height={22} color="#4096ff" /></div>
																								<div style={{ fontSize: "14px", color: "rgba(0, 0, 0, 0.85)" }}>
																									<div>Связать аккаунт c Max</div>
																								</div>
																							</div>
																						</a>
																					</div>
																				</div>
																			</div>
																		</div>
																	</div>}
																	{((event?.ID && event?.ID !== 861) || user?.maxchatid) && <Spin spinning={loading}>
																		<div style={{ paddingBottom: "25px" }}>
																			<SingleEvent auth={auth} event={event} size="small" />
																		</div>
																		{event && <>
																			{IfElse(
																				!dayjs(event.okonchanieSorevnovaniya).isBefore(dayjs()),
																				(<div>
																					{event && <Action
																						mode={"inline"}
																						auth={auth}

																						nextText="Подтвердить заказ"
																						okText="Оплатить"

																						action={actionFunc}
																						steps={steps}
																					/>}
																				</div>),
																				(<div style={{ fontSize: "20px" }}>
																					<Result
																						className={classes.Result}
																						icon={<img src={greenClock} className="spe am-icon" style={{ width: "60px", height: "60px" }} alt="" />}
																						title="Мероприятие завершено"
																						extra={
																							<div style={{ fontSize: "16px" }}>Билеты на это мероприятие больше не доступны</div>
																						}
																					/>
																				</div>))
																			}
																		</>}
																	</Spin>}
																</Spin>
															</div>
														</div>
													</div>
												</div>
											</Content>
											{showRightSider && <Sider width={185} theme={"light"}></Sider>}
										</Layout>
									</Content>
									<Footer style={{ textAlign: 'center' }}>
										Общероссийская физкультурно-спортивная общественная организация "Всероссийская федерация социальных танцев"
									</Footer>
								</Layout>}
								{(siteAccess == "deny") && <Layout>
									<FedHeader user={user} logout={logout} logoutall={logoutall} layout={layout} fullwidth={fullwidth} />
									{showSubheader && <FedSubheader layout={layout} fullwidth={fullwidth} changeFullwidth={changeFullwidth} />}
									<Content style={{ padding: '10px 10px 0 10px' }}>
										<Layout style={style().fullwidth.layout}>
											<Content style={{ ...style().content }}>
												<SiteAccessDeny {...props} />
											</Content>
										</Layout>
									</Content>
									<Footer style={{ textAlign: 'center' }}>
										Общероссийская физкультурно-спортивная общественная организация "Всероссийская федерация социальных танцев"
									</Footer>
								</Layout>}
							</LangSwitchContext.Provider>
						</LanguageContext.Provider>
					</UserConfigContext.Provider>
				</UserContext.Provider>
			</MetaContext.Provider>
		</TranslateContext.Provider>
	);
};

export default React.memo(Payment);
// Payment.whyDidYouRender = true